export default "__VITE_ASSET__B9Ktg2vZ__"